module.exports = __webpack_public_path__ + "img/estimate_logo.916a031e.png";